import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import { userAppContext } from '../../../Context/Context';
import { refreshSession } from '../../../services/RefreshSession';
import { UserContext } from '../../../types';
import LoadingSpinner from '../../../global/Loader/LoaderSpinner';

const SsoCallback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);
  
  const { setIsAuthenticated, setAuthorization, setGroups, setUser } = 
    userAppContext() as unknown as UserContext;

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const errorParam = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');
        
        if (errorParam) {
          throw new Error(errorDescription || `OAuth error: ${errorParam}`);
        }

        const user = await getCurrentUser();
        
        if (user) {
          const session = await refreshSession();
          const userInfo = session!.tokens!.idToken!.payload;
          const userGroups = userInfo['cognito:groups'];

          setUser(userInfo);
          setAuthorization(session!.tokens!.idToken!.toString());
          setGroups(userGroups);
          setIsAuthenticated(true);
          
          navigate('/');
        } else {
          throw new Error('Failed to authenticate user');
        }
      } catch (err) {
        console.error('SSO Callback Error:', err);
        const errorMessage = err instanceof Error ? err.message : 'Authentication failed';
        setError(errorMessage);
        
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } finally {
        setIsLoading(false);
      }
    };

    handleCallback();
  }, [navigate, setIsAuthenticated, setAuthorization, setGroups, setUser]);

  if (isLoading) {
    return (
      <div className="container txt-contenido">
        <div className="login-container mb-5">
          <div className="signin-container">
            <div className="col-12 text-center">
              <LoadingSpinner message="Completing SSO login..." />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container txt-contenido">
        <div className="login-container mb-5">
          <div className="signin-container">
            <div className="col-12 text-center">
              <h3 className="login-title" style={{ color: 'white' }}>SSO Login Error</h3>
              <p style={{ color: 'white', marginBottom: '20px' }}>{error}</p>
              <p style={{ color: 'white' }}>Redirecting to login page...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default SsoCallback;